import React from "react";

const FLAG_MAP = {
  en: { emoji: "🇺🇸", label: "United States" },
  vi: { emoji: "🇻🇳", label: "Vietnam" },
  hi: { emoji: "🇮🇳", label: "India" },
  zhs: { emoji: "🇨🇳", label: "Mainland China" },
  zht: { emoji: "🇹🇼", label: "Taiwan" },
  es: { emoji: "🇪🇸", label: "Spanish" },
  ar: { emoji: "🇸🇦", label: "Arabic" },
  fr: { emoji: "🇫🇷", label: "French" },
  bn: { emoji: "🇧🇩", label: "Bangladesh" },
  pt: { emoji: "🇧🇷", label: "Brazil" },
  ru: { emoji: "🇷🇺", label: "Russia" },
  ur: { emoji: "🇵🇰", label: "Pakistan" },
  id: { emoji: "🇮🇩", label: "Indonesia" },
  de: { emoji: "🇩🇪", label: "Germany" },
  ja: { emoji: "🇯🇵", label: "Japan" },
  mr: { emoji: "🇮🇳", label: "Marathi" },
  tr: { emoji: "🇹🇷", label: "Türkiye" },
  sw: { emoji: "🇹🇿", label: "Swahili" },
  ha: { emoji: "🇳🇬", label: "Hausa" },
  fil: { emoji: "🇵🇭", label: "Philippines" },
  ko: { emoji: "🇰🇷", label: "Korea" },
  fa: { emoji: "🇮🇷", label: "Persian" },
  pa: { emoji: "🇮🇳", label: "Punjabi" },
  am: { emoji: "🇪🇹", label: "Amharic" },
  th: { emoji: "🇹🇭", label: "Thailand" },
  jv: { emoji: "🇮🇩", label: "Javanese" },
  it: { emoji: "🇮🇹", label: "Italy" },
  pcm: { emoji: "🇳🇬", label: "Nigerian Pidgin" },
  ms: { emoji: "🇲🇾", label: "Malay" },
  pl: { emoji: "🇵🇱", label: "Poland" },
  uk: { emoji: "🇺🇦", label: "Ukraine" },
  nl: { emoji: "🇳🇱", label: "Netherlands" },
  ps: { emoji: "🇦🇫", label: "Pashto" },
  ro: { emoji: "🇷🇴", label: "Romania" },
  my: { emoji: "🇲🇲", label: "Myanmar" },
  om: { emoji: "🇪🇹", label: "Oromo" },
  so: { emoji: "🇸🇴", label: "Somali" },
  ne: { emoji: "🇳🇵", label: "Nepali" },
  az: { emoji: "🇦🇿", label: "Azerbaijani" },
  mg: { emoji: "🇲🇬", label: "Malagasy" },
};

export default function CountryFlagsUI({
  marketCode,
  fallbackCode = "en",
  className = "text-lg relative -top-0.5",
}) {
  const normalizedCode = String(marketCode || "").toLowerCase();
  const fallback = FLAG_MAP[String(fallbackCode || "en").toLowerCase()] || FLAG_MAP.en;
  const flag = FLAG_MAP[normalizedCode] || fallback;

  if (!flag) return null;

  return (
    <span role="img" className={className} aria-label={flag.label}>
      {flag.emoji}
    </span>
  );
}
